module["exports"] = [
  "Բն. ###",
  "Տուն ###"
];
